import "nprogress/nprogress.css";
import { start, done, configure } from "nprogress";
import NotFound from "@/components/util/NotFound.vue";

configure({
  trickleSpeed: 20,
  showSpinner: false,
})

function delay(duration) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, duration)
  })
}

function getPageComponent(pageCompResolver) {
  return async () => {
    start();
    if (process.env.NODE_ENV === "development") {
      await delay(500);
    }
    const comp = await pageCompResolver();
    done();
    return comp;
  }
}

export default [
  {
    name: "Auth",
    path: "/auth",
    component: getPageComponent(
      () => import(/* webpackChunkName: "Auth" */ "@/components/util/Auth.vue")
    ),
  },
  {
    name: "Home",
    path: "/",
    component: getPageComponent(
      () => import(/* webpackChunkName: "Home" */ "@/views/Home")
    ),
    meta: {
      title: "首页",
      requiresAuth: true,
    }
  },
  {
    name: "Active",
    path: "/active",
    component: getPageComponent(
      () => import(/* webpackChunkName: "Active" */ "@/views/Active")
    ),
    meta: {
      title: "活动中心",
      requiresAuth: false,
    }
  },
  {
    name: "MyActive",
    path: "/mineactive",
    component: getPageComponent(
      () => import(/* webpackChunkName: "MyActive" */ "@/views/Active/MyActive.vue")
    ),
    meta: {
      title: "我的报名",
      requiresAuth: false,
    }
  },
  {
    name: "Shop",
    path: "/shop",
    component: getPageComponent(
      () => import(/* webpackChunkName: "Shop" */ "@/views/Shop")
    ),
    meta: {
      title: "积分",
      requiresAuth: true,
    }
  },
  {
    name: "Mine",
    path: "/mine",
    component: getPageComponent(
      () => import(/* webpackChunkName: "Mine" */ "@/views/Mine")
    ),
    meta: {
      title: "我的",
      requiresAuth: true,
    }
  },
  {
    name: "ZfMsg",
    path: "/zfmsg",
    component: getPageComponent(
      () => import(/* webpackChunkName: "ZfMsg" */ "@/views/services/zfmsg/ZfMsg.vue")
    ),
    meta: {
      title: "祝福语",
      requiresAuth: true,
    }
  },
  {
    name: "ActiveDetail",
    path: "/active/:aid",
    component: getPageComponent(
      () => import(/* webpackChunkName: "ActiveDetail" */ "@/views/Active/Detail")
    ),
    meta: {
      title: "活动详情",
      requiresAuth: true,
    }
  },
  {
    name: "ShangWuContent",
    path: "/swcontent/:name",
    component: getPageComponent(
      () => import(/* webpackChunkName: "ShangWuContent" */ "@/components/util/ShangWuContent.vue")
    ),
    meta: {
      requiresAuth: true,
    }
  },
  {
    name: "UserInfo",
    path: "/userinfo",
    component: getPageComponent(
      () => import(/* webpackChunkName: "UserInfo" */ "@/views/user/UserInfo.vue")
    ),
    meta: {
      title: "设置",
      requiresAuth: true,
    }
  },
  {
    name: "Equity",
    path: "/equity",
    component: getPageComponent(
      () => import(/* webpackChunkName: "Equity" */ "@/views/user/Equity.vue")
    ),
    meta: {
      title: "权益中心",
      requiresAuth: true,
    }
  },
  {
    name: "AppShow",
    path: "/app",
    component: getPageComponent(
      () => import(/* webpackChunkName: "AppShow" */ "@/views/AppShow")
    ),
    meta: {
      requiresAuth: false,
    }
  },
  {
    name: "LuckDraw",
    path: "/activeluckdraw",
    component: getPageComponent(
      () => import(/* webpackChunkName: "LuckDraw" */ "@/views/game/LuckDraw.vue")
    ),
    meta: {
      title: "幸运抽奖",
      requiresAuth: false,
    }
  },
  {
    name: "AddressHistory",
    path: "/addresshistory",
    component: getPageComponent(
      () => import(/* webpackChunkName: "AddressHistory" */ "@/views/user/AddressHistory.vue")
    ),
    meta: {
      title: "历年订阅详情",
      requiresAuth: true,
    }
  },
  {
    name: "ProductDetail",
    path: "/productdetail",
    component: getPageComponent(
      () => import(/* webpackChunkName: "ProductDetail" */ "@/views/Product/ProductDetail.vue")
    ),
    meta: {
      title: "商品详情",
      requiresAuth: false,
    }
  },
  {
    name: "NotFound",
    path: "/:pathMatch(.*)*",
    component: NotFound
  },
]